import React, { useCallback, useEffect, useState } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-easybutton/src/easy-button.js';
import 'leaflet-easybutton/src/easy-button.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

const LocationMarker = ({ map, callBack }) => {
  const [position, setPosition] = useState([29.620207, 51.652271]);

  const onClick = useCallback(() => {
    map.locate().on('locationfound', function (e) {
      setPosition(e.latlng);
      map.setView(e.latlng, map.getZoom());
    });
  }, [map]);

  const onMove = useCallback(() => {
    callBack(map.getCenter());
    setPosition(map.getCenter());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callBack, map]);

  useEffect(() => {
    map.on('move', onMove);
    callBack(map.getCenter());
    return () => {
      map.off('move', onMove);
    };
  }, [callBack, map, onMove]);

  return position === null ? null : (
    <>
      <Marker position={position} icon={DefaultIcon} />
      <button
        className="location-finder relative top-5 bg-slate-700 text-white p-2 rounded-full"
        style={{ left: '95%', zIndex: '405' }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
      >
        Me
      </button>
    </>
  );
};

export default LocationMarker;
